import React, { memo } from 'react';

import Box from '../Box/Box';
import { TPageContent } from './types/TPage';

const PageContent = ({ as = 'div', children, ...rest }: TPageContent) => {
  return (
    <Box {...rest} parent="Page" name="content" as={as}>
      {children}
    </Box>
  );
};

export default memo(PageContent);
